// Recovered compiled webpack factory 96868. Edit this function expression; run npm run build.
(t, e, i) => {
  i.d(e, { W: () => a });
  var n = i(37822);
  let s = { ...n.ai, transform: Math.round };
  var r = i(92419);
  let o = {
      rotate: r.uj,
      rotateX: r.uj,
      rotateY: r.uj,
      rotateZ: r.uj,
      scale: n.hs,
      scaleX: n.hs,
      scaleY: n.hs,
      scaleZ: n.hs,
      skew: r.uj,
      skewX: r.uj,
      skewY: r.uj,
      distance: r.px,
      translateX: r.px,
      translateY: r.px,
      translateZ: r.px,
      x: r.px,
      y: r.px,
      z: r.px,
      perspective: r.px,
      transformPerspective: r.px,
      opacity: n.X4,
      originX: r.gQ,
      originY: r.gQ,
      originZ: r.px,
    },
    a = {
      borderWidth: r.px,
      borderTopWidth: r.px,
      borderRightWidth: r.px,
      borderBottomWidth: r.px,
      borderLeftWidth: r.px,
      borderRadius: r.px,
      borderTopLeftRadius: r.px,
      borderTopRightRadius: r.px,
      borderBottomRightRadius: r.px,
      borderBottomLeftRadius: r.px,
      width: r.px,
      maxWidth: r.px,
      height: r.px,
      maxHeight: r.px,
      top: r.px,
      right: r.px,
      bottom: r.px,
      left: r.px,
      inset: r.px,
      insetBlock: r.px,
      insetBlockStart: r.px,
      insetBlockEnd: r.px,
      insetInline: r.px,
      insetInlineStart: r.px,
      insetInlineEnd: r.px,
      padding: r.px,
      paddingTop: r.px,
      paddingRight: r.px,
      paddingBottom: r.px,
      paddingLeft: r.px,
      paddingBlock: r.px,
      paddingBlockStart: r.px,
      paddingBlockEnd: r.px,
      paddingInline: r.px,
      paddingInlineStart: r.px,
      paddingInlineEnd: r.px,
      margin: r.px,
      marginTop: r.px,
      marginRight: r.px,
      marginBottom: r.px,
      marginLeft: r.px,
      marginBlock: r.px,
      marginBlockStart: r.px,
      marginBlockEnd: r.px,
      marginInline: r.px,
      marginInlineStart: r.px,
      marginInlineEnd: r.px,
      fontSize: r.px,
      backgroundPositionX: r.px,
      backgroundPositionY: r.px,
      ...o,
      zIndex: s,
      fillOpacity: n.X4,
      strokeOpacity: n.X4,
      numOctaves: s,
    };
}
